import { z } from 'zod';
import { e164Schema } from './schemas.js';
/**
 * Contacts: cards the team keeps about customers, with their numbers. A
 * contact's calls are found by those numbers, each with what was said (the
 * AI review's summary), and the card shows when they call.
 */
const optionalText = (max) => z
    .string()
    .trim()
    .max(max)
    .nullable()
    .default(null)
    .transform((v) => v || null);
export const contactNumberSchema = z.object({
    e164: e164Schema,
    label: optionalText(30),
});
export const contactSchema = z.object({
    name: z.string().trim().min(1, 'Give a name').max(120),
    company: optionalText(120),
    email: z
        .union([z.literal(''), z.email('Not an email address')])
        .nullable()
        .default(null)
        .transform((v) => v || null),
    notes: z.string().max(10_000).default(''),
    numbers: z
        .array(contactNumberSchema)
        .max(20)
        .refine((numbers) => new Set(numbers.map((n) => n.e164)).size === numbers.length, 'A number is in the list twice'),
});
/**
 * What to show about a caller's earlier calls while they're on the line: the
 * last conversations (calls answered, with what was said), not the attempts
 * that didn't connect in between; the latest calls when there was none.
 */
export function lastConversations(calls, count = 3) {
    const talked = calls.filter((call) => call.outcome === 'ANSWERED' || call.summary);
    return (talked.length > 0 ? talked : calls).slice(0, count);
}
